import React, { Component } from 'react';
// import PropTypes from 'prop-types';

import LoginForm from 'components/LoginForm';

export class SignupPage extends Component {
  render() {
    const { history, authStateChanged } = this.props;

    return (
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4">
            <h1 className="mb-3 text-center">Signup</h1>
            <LoginForm
              // email="test@test.gen.co"
              debug={true}
              onAuthentication={({ token, user }) => {
                console.log({ token, user });
                localStorage.setItem('token', token);
                authStateChanged({ user });
                history.push('/');
              }}
            />
            <hr />
            <h4>Where's the password?</h4>
            <p>
              There isn't one! Apricotbook uses{' '}
              <a href="https://secondfactorauth.com">
                second factor authentication
              </a>, which is more secure than a password and easier to use.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
SignupPage.propTypes = {};

export default SignupPage;



// WEBPACK FOOTER //
// ./src/pages/SignupPage.js